import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';
import { defaultGcTime, defaultStaleTime } from '@/shared/constants';
import { useQuery } from '@tanstack/react-query';

import { get } from '@truefit/http-utils';

/** Player-config modes that can carry a default output-profile assignment. */
export type OutputProfileMode = 'interactive' | 'wsc' | 'clip_export_default' | 'clip_export_portrait';

export interface OutputProfileSummary {
  id: number;
  name: string;
  displayName: string | null;
  description: string | null;
}

export interface OutputProfilesResponse {
  profiles: OutputProfileSummary[];
  assignments: Record<OutputProfileMode, number | null>;
}

export const OUTPUT_PROFILES_QUERY_KEY = ['OutputProfiles'];

export const useOutputProfilesQuery = () => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: OUTPUT_PROFILES_QUERY_KEY,
    queryFn: async () => {
      const { data } = await get<OutputProfilesResponse>('/v1.0/internals/output-profiles');
      return data;
    },
    enabled: isReady,
    staleTime: defaultStaleTime,
    gcTime: defaultGcTime,
  });
};

export default useOutputProfilesQuery;
